import {
  getGroundOpticsTierLabel,
  getHighAltitudeOpticsTierLabel,
} from '@/lib/utils/optics-paliers';

/** Tier label only (no numeric optics), same thresholds as `displayOptics` for ground / low-alt GRU. */
export function getOpticsTierLabel(optics: number): string {
  return getGroundOpticsTierLabel(optics);
}

/** Tailwind text classes approximating in-game optics tier colors (red … blue). */
export function opticsTierClassName(optics: number): string {
  const label = getOpticsTierLabel(optics);
  switch (label) {
    case 'Bad':
      return 'text-red-600 dark:text-red-400';
    case 'Mediocre':
      return 'text-orange-600 dark:text-orange-400';
    case 'Normal':
      return 'text-yellow-600 dark:text-yellow-400';
    case 'Good':
      return 'text-lime-600 dark:text-lime-400';
    case 'Very Good':
      return 'text-green-600 dark:text-green-400';
    case 'Exceptional':
      return 'text-sky-600 dark:text-sky-400';
    default:
      return 'text-foreground';
  }
}

/** Ground or low-altitude optical strength GRU (parenthetical raw value). */
export function displayOptics(optics: number): string {
  const label = getGroundOpticsTierLabel(optics);
  return `${label} (${optics})`;
}

/** High-altitude (air) optical strength GRU — uses PaliersDOptiqueDAltitudeGRU when in new scale. */
export function displayAirOptics(optics: number): string {
  const label = getHighAltitudeOpticsTierLabel(optics);
  return `${label} (${optics})`;
}
